import React from 'react';

const NotificationBar = ({children}) => {

    return (
        <div className='notificationBar'>
            {children}
        </div>
    )
}

export default NotificationBar



// WEBPACK FOOTER //
// ./resources/js/components/NotificationBar.js